<template>
  <v-card id="create">
    <v-speed-dial
      v-if="showFloat"
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="white" dark small fab>
          <v-icon color="#757575" v-if="fab"> mdi-close </v-icon>
          <v-icon color="#757575" v-else> mdi-link-variant </v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="grey" @click="gotoLinkedin()">
        <v-icon>mdi-linkedin</v-icon>
      </v-btn>
      <v-btn fab dark small color="grey" @click="gotoTwitter()">
        <v-icon>mdi-twitter</v-icon>
      </v-btn>
      <v-btn fab dark small color="grey" @click="gotoMedium()">
        <v-img
          src="/img/medium-icon-grey-square-inverted.png"
          width="42px"
          style="border-radius: 30px"
        >
        </v-img>
      </v-btn>
    </v-speed-dial>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    windowWidth: window.innerWidth,
    direction: 'top',
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: true,
    left: false,
    showFloat: true,
    transition: "slide-y-reverse-transition",
  }),
  methods: {
    gotoLinkedin() {
      const refUrl = "https://tr.linkedin.com/in/ercanosmanoglu";
      window.open(refUrl, "_blank");
    },
    gotoMedium() {
      const refUrl = "https://medium.com/@ercanosmanoglu";
      window.open(refUrl, "_blank");
    },
    gotoTwitter() {
      const refUrl = "https://twitter.com/osmanogluercan";
      window.open(refUrl, "_blank");
    },
  },
  computed: {
    activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    },
  },
  mounted() {
    window.addEventListener("resize", (size) => {
      console.log("Size:", size);
      this.windowWidth = window.innerWidth;
      //console.log("this.windowWidth:", this.windowWidth);
    });
  },
  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },/*
    windowWidth(val) {
      if(this.showFloat===false)return;
      console.log("Val is:", val);
      if (val > 820) {
        //if (this.direction === 'top') return;
        this.showFloat = false;
        this.direction = "bottom";
        this.bottom = false;
        this.top = true;
        setTimeout(() => {
          this.showFloat = true;
        }, 1000);
      } else {
        //if (this.direction === 'bottom') return;
        this.showFloat = false;
        this.direction = "top";
        this.bottom = true;
        this.top = false;

        setTimeout(() => {
          this.showFloat = true;
        }, 1000);
      }
    },*/
  },
};
</script>
<style>
/* This is for documentation purposes and will not be needed in your application */
#create .v-speed-dial {
  position: fixed;
  z-index: 10;

  right: 15px;
  bottom: 15px;
}

#create .v-btn--floating {
  position: fixed;
}
</style>